import { render, staticRenderFns } from "./infoList.vue?vue&type=template&id=1e73758c&scoped=true&"
import script from "./infoList.vue?vue&type=script&lang=js&"
export * from "./infoList.vue?vue&type=script&lang=js&"
import style0 from "./infoList.vue?vue&type=style&index=0&id=1e73758c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e73758c",
  null
  
)

export default component.exports